module.exports = __webpack_public_path__ + "static/media/gailKim58.6c989158.png";